import { useQuery } from '@tanstack/react-query';
import { useIsAdmin } from '@/api/hooks/useAuth';
import { versionService } from '@/api/services/version';

export const buildVersionQueryKey = ['version'] as const;

/** The build manifest baked into the image. Immutable for the lifetime of the
 *  page, hence `staleTime: Infinity`; best-effort, hence `retry: false`. Only
 *  admins are shown the version, so only admins fetch it. */
export function useBuildVersion() {
  const isAdmin = useIsAdmin();
  return useQuery({
    queryKey: buildVersionQueryKey,
    queryFn: versionService.buildVersion,
    enabled: isAdmin,
    staleTime: Infinity,
    retry: false,
  });
}
